import React, { useEffect } from "react";
import { motion } from "framer-motion";
import Services from "./services";

const ServiceMain = () => {
  useEffect(() => {
    // Scroll to the top of the page when the component loads
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <motion.div
      className="mt-20"
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1, ease: "easeInOut" }}
    >
      <Services />
    </motion.div>
  );
};

export default ServiceMain;
